var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      {
        staticClass: "card",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-body",
          },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "3",
                    },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.loanType,
                        "item-text": "label",
                        "item-value": "val",
                        label: "เลือกการยืม",
                        outlined: "",
                      },
                      model: {
                        value: _vm.query.loan,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "loan", $$v)
                        },
                        expression: "query.loan",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "4",
                    },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.agents,
                        "item-text": "name",
                        "item-value": "id",
                        label: "เลือกเอเจน",
                        outlined: "",
                      },
                      model: {
                        value: _vm.query.agentId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "agentId", $$v)
                        },
                        expression: "query.agentId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "3",
                    },
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        align: "center",
                        label: "กรอกจำนวนเงิน",
                        outlined: "",
                        pattern: "\\d{5,8}",
                        maxlength: "8",
                        min: "5",
                        required: "",
                      },
                      on: {
                        keypress: function ($event) {
                          return _vm.validateNumber($event)
                        },
                      },
                      model: {
                        value: _vm.amount,
                        callback: function ($$v) {
                          _vm.amount = $$v
                        },
                        expression: "amount",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "2",
                    },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "success",
                          large: "",
                        },
                        on: {
                          click: _vm.addLoan,
                        },
                      },
                      [_vm._v("\n            บันทึก\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card mt-5",
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-body",
          },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "5",
                    },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.agents,
                        "item-text": "name",
                        "item-value": "id",
                        label: "เลือกเอเจน",
                        outlined: "",
                      },
                      model: {
                        value: _vm.agentId,
                        callback: function ($$v) {
                          _vm.agentId = $$v
                        },
                        expression: "agentId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "5",
                    },
                  },
                  [
                    _c(
                      "v-menu",
                      {
                        ref: "showDateDialog",
                        attrs: {
                          "close-on-content-click": false,
                          "return-value": _vm.dateSelect,
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "auto",
                        },
                        on: {
                          "update:returnValue": function ($event) {
                            _vm.dateSelect = $event
                          },
                          "update:return-value": function ($event) {
                            _vm.dateSelect = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function (_ref) {
                              var on = _ref.on,
                                attrs = _ref.attrs
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          label: "วันที่",
                                          outlined: "",
                                        },
                                        model: {
                                          value: _vm.dateSelectDisplay,
                                          callback: function ($$v) {
                                            _vm.dateSelectDisplay = $$v
                                          },
                                          expression: "dateSelectDisplay",
                                        },
                                      },
                                      "v-text-field",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.showDateDialog,
                          callback: function ($$v) {
                            _vm.showDateDialog = $$v
                          },
                          expression: "showDateDialog",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c("v-date-picker", {
                          attrs: {
                            "no-title": "",
                          },
                          on: {
                            change: function ($event) {
                              _vm.$refs.showDateDialog.save(
                                _vm.dateSelectDisplay
                              )
                              _vm.showDateDialog = false
                            },
                          },
                          model: {
                            value: _vm.dateSelect,
                            callback: function ($$v) {
                              _vm.dateSelect = $$v
                            },
                            expression: "dateSelect",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "2",
                    },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          large: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData(_vm.query.slug)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                            },
                          },
                          [_vm._v("\n              mdi-check\n            ")]
                        ),
                        _vm._v("\n            ค้นหา\n          "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "elevation-0",
              attrs: {
                "footer-props": _vm.footer,
                headers: _vm.headers,
                items: _vm.items,
                loading: _vm.loading,
                "multi-sort": false,
                options: _vm.options,
                "server-items-length": _vm.totalItems,
                "item-key": "id",
              },
              on: {
                "update:items": function ($event) {
                  _vm.items = $event
                },
                "update:options": function ($event) {
                  _vm.options = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.created_at",
                  fn: function (_ref2) {
                    var item = _ref2.item
                    return [
                      item.created_at
                        ? _c(
                            "span",
                            {
                              staticClass: "d-block",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(item.created_at)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (_ref3) {
                    var item = _ref3.item
                    return [
                      item.type == "debit"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "green",
                                outlined: "",
                              },
                            },
                            [
                              _vm._v("\n            ให้ยืม "),
                              _c("v-icon", [_vm._v("mdi-arrow-right-thick")]),
                            ],
                            1
                          )
                        : item.type == "credit"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "red",
                                outlined: "",
                              },
                            },
                            [
                              _vm._v("\n            ดึงคืน "),
                              _c("v-icon", [_vm._v("mdi-arrow-left-thick")]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (_ref4) {
                    var item = _ref4.item
                    return [
                      item.status == "request"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "red",
                                outlined: "",
                              },
                            },
                            [_vm._v("\n            ปฏิเสธรายการ\n          ")]
                          )
                        : item.status == "approved"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "blue",
                                outlined: "",
                              },
                            },
                            [_vm._v("\n            อนุมัติ\n          ")]
                          )
                        : _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "gray",
                                outlined: "",
                              },
                            },
                            [_vm._v("\n            ยกเลิกรายการ\n          ")]
                          ),
                    ]
                  },
                },
                {
                  key: "item.user",
                  fn: function (_ref5) {
                    var item = _ref5.item
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.result_limit.user.name) +
                          "\n        "
                      ),
                    ]
                  },
                },
                {
                  key: "item.amount",
                  fn: function (_ref6) {
                    var item = _ref6.item
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(Intl.NumberFormat("th-TH").format(item.amount))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header",
      },
      [_c("h2", [_vm._v("ทำรายการยืม/คืน")])]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header",
      },
      [_c("h2", [_vm._v("รายการ")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }